"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reward = void 0;
var types_1 = require("./types");
// tslint:disable:variable-name
var Reward = /** @class */ (function () {
    function Reward(data) {
        this.category_id = data.category_id;
        this.current_quantity = data.current_quantity;
        this.date_end = data.date_end;
        this.date_end_redeemable = data.date_end_redeemable;
        this.date_start = data.date_start;
        this.description = data.description;
        this.extra_data = data.extra_data;
        this.featured_order_num = data.featured_order_num;
        this.freq_cap = data.freq_cap;
        this.freq_period_id = data.freq_period_id;
        this.freq_period_name = data.freq_period_name;
        this.group_id = data.group_id;
        this.id = data.id;
        this.image = data.image;
        this.is_digital_download = data.is_digital_download;
        this.is_enabled = data.is_enabled;
        this.is_min_age_required = data.is_min_age_required;
        this.is_phone_number_required = data.is_phone_number_required;
        this.is_shipping_required = data.is_shipping_required;
        this.max_per_user = data.max_per_user;
        this.max_select_quantity = data.max_select_quantity;
        this.min_age = data.min_age;
        this.min_tier_id = data.min_tier_id;
        this.no_end_date = data.no_end_date;
        this.num_points = data.num_points;
        this.remaining_coupons = data.remaining_coupons;
        this.reward_terms = data.reward_terms;
        this.sweepstake_winners = data.sweepstake_winners;
        this.title = data.title;
        this.total_coupons = data.total_coupons;
        this.total_quantity = data.total_quantity;
    }
    Object.defineProperty(Reward.prototype, "isFeatured", {
        get: function () {
            return this.featured_order_num !== undefined && this.featured_order_num !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reward.prototype, "rules", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('rules_link') ? this.extra_data.rules_link : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reward.prototype, "drawDate", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('draw_date') ? this.extra_data.draw_date : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reward.prototype, "isSweepstakes", {
        get: function () {
            return !!this.sweepstake_winners;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reward.prototype, "isClaimForFree", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('claim_free_entry') ? this.extra_data.claim_free_entry : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reward.prototype, "isHiddenFromList", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('view') && this.extra_data.view === 'hidden';
        },
        enumerable: false,
        configurable: true
    });
    Reward.JsonToRewards = function (data) {
        var rewardList = new types_1.RewardList();
        data.forEach(function (reward) {
            if (!!reward.extra_data && reward.extra_data.hasOwnProperty('view') && reward.extra_data.view === 'hidden')
                return;
            rewardList.push(Reward.JsonToReward(reward));
        });
        return rewardList;
    };
    Reward.JsonToReward = function (data) { return new Reward(data); };
    return Reward;
}());
exports.Reward = Reward;
//# sourceMappingURL=Reward.js.map